import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { formValueSelector } from 'redux-form'

import AccountDetailsModal from '../../AccountDetails/AccountDetailsModal'

const DebitAccountDetailsTrigger: FC<{ FormName: string }> = ({ FormName }) => {
  const selectFormValue = formValueSelector(FormName)

  const ID: number = useSelector((state) => selectFormValue(state, 'DebitAccID'))
  const hash: string = useSelector((state) => selectFormValue(state, 'DebitAccHash'))

  //@ts-ignore
  return <AccountDetailsModal name="DebitAccountDetails" disabled={!ID || !hash} ID={ID} hash={hash} />
}

export default DebitAccountDetailsTrigger
